var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_c('header-logo-icon'),_vm._v(" "),_c('header-logo-text')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }